(function() {
  console.log('front property.js');
  var property = function() {
    var activeIndex = 0;
    var maxindex;
    var scrolling = null;
    var flg = {prev: 0, next: 1};
    var navPositionLeft = 0;

    var init = function() {
      // 初期処理
      maxindex = $('.js-slide-nav-item').length - 1;
      $('.js-slide-count').text((activeIndex + 1) + '/' + (maxindex + 1) + '枚')

      // event
      $('.js-slide-nav-item').on('click', function() {
        activeIndex = $(this).data('nav-index');
        view();
        return false;
      });
      $('.js-slide-nav-item').on('click', function() {
        view();
        return false;
      });
      $('.js-slide-view-prev').on('click', prevHnadler);
      $('.js-slide-view-next').on('click', nextHnadler);
      $('.js-slide-nav-prev').on('click', function() {
        return false;
      });
      $('.js-slide-nav-next').on('click', function() {
        return false;
      });
      $('.js-slide-nav-prev').on('mousedown', flg.prev, startScrollHandler);
      $('.js-slide-nav-prev').on('mouseup', stopScrollHandler);
      $('.js-slide-nav-prev').on('mouseout', stopScrollHandler);
      $('.js-slide-nav-next').on('mousedown', flg.next, startScrollHandler);
      $('.js-slide-nav-next').on('mouseup', stopScrollHandler);
      $('.js-slide-nav-next').on('mouseout', stopScrollHandler);

    }

    var view = function() {
      var $slide = $('.js-slide-view');
      var $item = $('.js-slide-view-item');
      var left = $item.eq(activeIndex).position().left + $slide.scrollLeft();
      $slide.animate({scrollLeft: left}, 0, 'swing');
      $('.js-slide-count').text((activeIndex + 1) + '/' + (maxindex + 1) + '枚');
      navActive();
    }

    var navScroll = function(action) {
      var $nav = $('.js-slide-nav');
      var $item = $('.js-slide-nav-item');
      var maxScrollLeft = $nav.get(0).scrollWidth - $nav.width();
      if (action === flg.prev) {
        if (navPositionLeft >= 0) {
          navPositionLeft -= $item.width();
          if (navPositionLeft < 0) navPositionLeft = 0;
        }
      } else if (action === flg.next) {
        if (navPositionLeft <= maxScrollLeft) {
          navPositionLeft += $item.width();
        }
      }
      $nav.animate({scrollLeft: navPositionLeft}, 0, 'linear');
    }

    var navActive = function() {
      $('.js-slide-nav-item.--active').removeClass('--active');
      $('.js-slide-nav-item').eq(activeIndex).addClass('--active');

      var $nav = $('.js-slide-nav');
      var scrollWidth = $nav.get(0).scrollWidth;
      var navWidth = $nav.width();
      var maxleft = scrollWidth - navWidth;
      var laftIndex = (activeIndex < 3) ? 0 : activeIndex - 3;
      var position = $('.js-slide-nav-item').eq(laftIndex).position().left - $('.js-slide-nav-prev').width()
      navPositionLeft += position;
      if (navPositionLeft >= maxleft) {
        navPositionLeft = maxleft;
      }
      $('.js-slide-nav').animate({scrollLeft: navPositionLeft}, 0, 'swing');
    }

    var nextHnadler = function(e) {
      if (activeIndex < maxindex) {
        activeIndex++;
      } else {
        activeIndex = 0;
      }
      view();
      return false;
    }

    var prevHnadler = function(e) {
      if (activeIndex > 0) {
        activeIndex--;
      } else {
        activeIndex = maxindex;
      }
      view();
      return false;
    }

    var startScrollHandler = function(e) {
      if (scrolling === null) {
        scrolling = setInterval(navScroll, 120, e.data);
      }
      return false;
    }

    var stopScrollHandler = function(e) {
      if (scrolling !== null) {
        clearInterval(scrolling);
        scrolling = null;
      }
      return false;
    }

    return {
      init: init
    }
  }();
  property.init();
})()
